module.exports = __webpack_public_path__ + "img/9.5032f09a.png";